<tra-md [slug]="getDescriptionSlug()" style="margin-bottom:1em;">
  <!-- You can search applicants by name, email or UID.
  There's a limit of 100 records that will get pulled per request, so be as specific as you need to be.
  Your timezone is {{timezone}}. -->
</tra-md>

<!-- <table class="table is-bordered" style="width: 28em;"> -->
  <div class="user-search-fields">
    <div class="input-row">
      <label class="label" for="uid"><tra slug="caec_lbl_cand_uid"></tra></label>
      <div class="input-field">
        <input autocomplete="off" name="uid" id="uid" [formControl]="candUID" type="text" class=input />
      </div>
    </div>
    <div *ngIf="!noNameSearch" class="input-row">
      <label class="label" for="first"><tra slug="abed_first_name"></tra></label>
      <div class="input-field">
        <input autocomplete="off" name="first" id="first" [formControl]="firstName" type="text" class=input />
      </div>
    </div>
    <div *ngIf="!noNameSearch" class="input-row">
      <label class="label" for="last"><tra slug="abed_last_name"></tra></label>
      <div class="input-field">
        <input autocomplete="off" name="last" id="last" [formControl]="lastName" type="text" class=input />
      </div>
    </div>
    <div class="input-row">
      <label class="label" for="email"><tra slug="lbl_email_addr"></tra></label>
      <div class="input-field">
        <input autocomplete="off" name="email" id="email" [formControl]="contactEmail" type="text" class=input />
      </div>
    </div>
  </div>

  <div style="margin-bottom: 2em;">
    <button class="button is-info" (click)="onSearchClick()" [disabled]="!validTTLookupVals()"><tra slug="btn_search"></tra></button>
    <button class="button" (click)="onResetClick()"><tra slug="mcq_reset_btn"></tra></button>
  </div>

  <!-- NOT USED FOR NOW - TBD -->
  <!-- <tr *ngIf="isSearchCompleted">
    <td></td>
    <td>
      <pre>Searching Completed</pre>
    </td>
  </tr>
  <tr *ngIf="isSearchCompleted && userInfo.length === 0">
    <td></td>
    <td>
      <pre>No results</pre>
    </td>
  </tr>
  <tr *ngIf="isSearchFailed">
    <td></td>
    <td>
      <pre>Searching Error: {{failReason}}</pre>
    </td>
  </tr> -->
  <!-- <tr>
    <td></td>
    <td> <button (click)="onSearchClick()" [disabled]="isSending">Search</button> </td>
  </tr> -->
<!-- </table> -->

<hr />